<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-2">
  <div class="sticky top-0 z-10 bg-white dark:bg-coal-600 mb-1">
    <div class="flex flex-row">
      <label
        class="block text-2sm font-medium mb-1 text-gray-900 dark:text-gray-300"
        [for]="fields.fieldName"
      >
        {{ fields.displayName }}
      </label>
    </div>
    <div class="flex search-wrapper rounded">
      <label class="input input-sm">
        <i class="ki-filled ki-magnifier"> </i>
        <input
          searchInput
          type="text"
          #searchInput
          (input)="onKeyUpSearch(searchInput.value)"
          class="w-full text-2sm p-2"
          [placeholder]="fields.placeholder"
        />
        <button
          *ngIf="searchInput.value"
          type="button"
          class="clear-btn text-xl"
          (click)="searchInput.value = ''; onKeyUpSearch('')"
        >
          ×
        </button>
      </label>
    </div>
  </div>
  <div class="mt-4 h-300px overflow-y-auto">
    <!-- ✅ SKELETON -->
    <div class="user-skeleton-list" *ngIf="isLoading">
      <div class="user-skeleton-row" *ngFor="let i of [1, 2, 3, 4, 5]">
        <div class="avatar shimmer-item bg-gray-300 dark:bg-coal-700"></div>

        <div class="details">
          <div class="name shimmer-item bg-gray-300 dark:bg-coal-700"></div>
          <div class="email shimmer-item bg-gray-300 dark:bg-coal-700"></div>
        </div>

        <div class="radio shimmer-item bg-gray-300 dark:bg-coal-700"></div>
      </div>
    </div>
    <ng-container *ngIf="fieldsData.length === 0 && !isLoading">
      <div class="flex justify-center items-center h-full w-full">
        <div class="flex justify-center items-center flex-col">
          <img
            src="./assets/media/icons/no-data.png"
            class="h-[100px] w-[100px]"
          />
          <span class="text-md text-center card-title">No data found</span>
          <span class="text-xs text-center text-gray-400"
            >There is no data to show you right now.</span
          >
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="fieldsData.length > 0 && !isLoading">
      <div *ngFor="let option of fieldsData; let i = index">
        <label
          class="mb-3 gap-2 border boder-gray-300 rounded flex items-center cursor-pointer rounded-md transition-colors duration-200 hover:bg-secondary-active p-4"
        >
          <input
            class="radio cursor-pointer"
            type="radio"
            [formControlName]="fields.fieldName"
            [value]="option"
          />
          <img [src]="option.iconUrl" class="h-30px w-30px" />
          <div class="me-auto">
            <span class="font-semibold text-sm text-gray-900">
              {{ option.platformName }}
            </span>
          </div>
          <div class="ms-auto">
            <span
              [ngClass]="{
                'badge-success': option.status == 'Connected',
                'badge-secondary': option.status == 'Disconnected',
              }"
              class="h-30px text-nowrap custom-badge badge badge-sm w-[150px] badge-outline rounded-md"
            >
              {{ option.status }}
            </span>
          </div>
        </label>
      </div>
    </ng-container>
  </div>
  <div *ngIf="showError" class="text-danger text-sm mt-1">
    Please select option
  </div>
</div>
